import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Buttons';
import Flex from '../Flex';
import MoreIcon from 'material-ui-icons/AddCircleOutline';
import LessIcon from 'material-ui-icons/RemoveCircleOutline';

export default class MoreLessButton extends Component {
    static propTypes = {
        highlighted: PropTypes.bool,
        onChange: PropTypes.func
    };
    static defaultProps = {
        open: false,
        highlighted: false,
        onChange: () => { }
    };

    constructor(...args) {
        super(...args)
        this.state = {
            open: this.props.open,
        }
    }

    onChange() {
        this.setState({
            open: !this.state.open
        })
        this.props.onChange(!this.state.open)
    }

    render() {
        let { highlighted } = this.props;
        return (
            <Button onClick={() => this.onChange()}
                        style={{
                    minWidth: 0,
                    textTransform: 'none',
                    color: '#000',
                    backgroundColor: highlighted ? '#f86c00' : '#FFFFFF',
                            marginRight: 2,
                            marginBottom: 2,
                        }}>
                    {
                        this.state.open ?
                            (
                                <Flex dir='ttb' c><LessIcon /><div>Show Less</div></Flex>
                            ) :
                            (
                                <Flex dir='ttb' c><MoreIcon /><div>Show More</div></Flex>
                            )
                    }
                </Button>
        )
    }
}
